// extracted by mini-css-extract-plugin
export default {"GenericDialog":"GenericDialog_GenericDialog__9LJRZ","contentModalBtn":"GenericDialog_contentModalBtn__+u737"};